export default "__VITE_ASSET__Dakf7bcp__"